import { AppDispatch } from 'config/redux'
import { createTask, setIsLoading } from 'redux/actions/tasks_v2'
import { setResponseStatus } from 'redux/actions/general'
import { createPrompt, PROMPT_TYPES } from 'redux/actions/promts'
import { createAIBriefingPop, createAIActionPop } from 'redux/actions/pops'
import { createJob, ICreateJob } from 'redux/actions/admin'
import { buildAiTaskPayload } from '../model/submission'

/** Existing authenticated thunks remain the transport/cache authority for every creation entry point. */
export function createAiTaskApi(dispatch: AppDispatch) {
  return {
    createPrompt: (
      input: Omit<Parameters<typeof createPrompt>[0], 'data'> & {
        data: { title: string; content: string }
      }
    ) => dispatch(createPrompt({ ...input, data: { ...input.data, prompt_type: PROMPT_TYPES.CUSTOM } })),
    createTask: (payload: ReturnType<typeof buildAiTaskPayload>) =>
      dispatch(createTask(payload, { keepLoading: true })) as unknown as Promise<string | null>,
    createBriefing: (input: Parameters<typeof createAIBriefingPop>[0]) =>
      dispatch(createAIBriefingPop(input)) as unknown as Promise<string | null>,
    createAction: (input: Parameters<typeof createAIActionPop>[0]) =>
      dispatch(createAIActionPop(input)) as unknown as Promise<string | null>,
    createJob: (input: ICreateJob) => dispatch(createJob(input)) as unknown as Promise<boolean>,
    releaseLoading: () => dispatch(setIsLoading(false)),
    complete: () => dispatch(setResponseStatus(true)),
  }
}
